// Floating Telegram support button — visible on ALL pages, bottom-right, above mobile nav.
export default function TelegramFab() {
  return (
    <a
      href="https://t.me/smskapida"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="telegram-fab"
      title="Canlı Destek — Telegram"
      className="fixed z-50 bottom-24 md:bottom-6 right-4 md:right-6 flex items-center gap-2 pl-3 pr-4 py-2.5 rounded-full shadow-2xl group transition-all hover:scale-105"
      style={{
        background: "linear-gradient(135deg, #229ED9 0%, #26A5E4 50%, #1e88bf 100%)",
        boxShadow: "0 10px 30px -8px rgba(34,158,217,0.55), 0 0 0 3px rgba(34,158,217,0.15)",
      }}
    >
      <span className="w-7 h-7 rounded-full bg-white/15 flex items-center justify-center backdrop-blur">
        <svg viewBox="0 0 24 24" fill="white" className="w-4 h-4">
          <path d="M21.9 4.5 2.7 12a.7.7 0 0 0 0 1.3l4.9 1.6 1.9 6.1a.7.7 0 0 0 1.2.3l2.7-2.8 5 3.7a.7.7 0 0 0 1.1-.4l3-16.1a.7.7 0 0 0-.9-.7Zm-3 3.6-8.7 7.9-.3 3.4L8.4 14 18.3 8Z" />
        </svg>
      </span>
      <span className="text-white text-xs md:text-sm font-bold leading-tight">
        <span className="block">Canlı Destek</span>
        <span className="block text-white/80 text-[10px] font-normal">@smskapida</span>
      </span>
      <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-[hsl(142,71%,50%)] border-2 border-white animate-pulse" />
    </a>
  );
}
